import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  Label,
  Button,
  FormGroup,
  Input,
  Form,
  Alert,
} from 'reactstrap';

const SystemForm = ({
  contactSubmission,
  sending,
  onChange,
  onSend,
  errors,
}) => {
  return (
    <Form>
      <Container>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="name">Name</Label>
              <Input
                type="text"
                name="name"
                id="name"
                value={contactSubmission.name}
                onChange={onChange}
              />
              {errors.name && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.name}
                </Alert>
              )}
            </FormGroup>
          </Col>

          <Col md={4}>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="text"
                id="email"
                name="email"
                value={contactSubmission.email}
                onChange={onChange}
              />
              {errors.email && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.email}
                </Alert>
              )}
            </FormGroup>
          </Col>

          <Col md={4}>
            <FormGroup>
              <Label for="phone">Phone</Label>
              <Input
                type="text"
                id="phone"
                name="phone"
                value={contactSubmission.phone}
                onChange={onChange}
              />
              {errors.phone && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.phone}
                </Alert>
              )}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormGroup>
              <Label for="message">Message</Label>
              <Input
                type="textarea"
                id="message"
                name="message"
                value={contactSubmission.message}
                onChange={onChange}
              />
              {errors.message && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.message}
                </Alert>
              )}
            </FormGroup>
            <FormGroup>
              <Button
                color="primary"
                type="submit"
                disabled={sending}
                onClick={onSend}
                className="mr-2"
              >
                {sending ? 'Sending' : 'Send'}
              </Button>
            </FormGroup>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

SystemForm.propTypes = {
  contactSubmission: PropTypes.object.isRequired,
};

export default SystemForm;



// WEBPACK FOOTER //
// ./src/components/contact/ContactForm.js